var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM15.4415 15.6926C14.0276 17.0446 12.1108 17.875 10 17.875C7.88923 17.875 5.97242 17.0446 4.55846 15.6926C5.40432 9.34069 14.5957 9.3407 15.4415 15.6926ZM16.3769 14.6216C15.7533 12.2283 14.0565 10.7267 12.0861 10.1167C13.0895 9.4437 13.75 8.29898 13.75 7C13.75 4.92893 12.0711 3.25 10 3.25C7.92893 3.25 6.25 4.92893 6.25 7C6.25 8.29898 6.91046 9.4437 7.9139 10.1167C5.9435 10.7267 4.24665 12.2283 3.62306 14.6216C2.68072 13.3236 2.125 11.7267 2.125 10C2.125 5.65076 5.65076 2.125 10 2.125C14.3492 2.125 17.875 5.65076 17.875 10C17.875 11.7267 17.3193 13.3236 16.3769 14.6216ZM10 9.625C11.4497 9.625 12.625 8.44975 12.625 7C12.625 5.55025 11.4497 4.375 10 4.375C8.55025 4.375 7.375 5.55025 7.375 7C7.375 8.44975 8.55025 9.625 10 9.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user_avatar.41943b03c07bd127c53d60b04a9b1ba5.svg";
export { ForwardRef as ReactComponent };